import { Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  countContainer: {
    borderRadius: "5px",
    height: "7vh",
    padding: "1vw",
    width: "9vw",
    color: "#fff",
  },
  dataContainer: {
    boxShadow:
      "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
    borderRadius: "5px",
    padding: "1vw",
  },
  head1: {
    fontFamily: "'Poppins', sansSerif",
    color: "#5A9BB7",
    fontWeight: "200",
    fontSize: "16px",
  },
  head2: {
    fontFamily: "'Poppins', sansSerif",
    color: "#5A9BB7",
    fontWeight: "500",
    fontSize: "16px",
  },
}));

export default function MyQueues() {
  const classes = useStyles();
  const [joinedQueues, setJoinedQueues] = useState([]);
  const [choosenTab, setChoosenTab] = useState(0);

  useEffect(() => {
    Axios.post(
      "https://asia-east2-apnaq-prod.cloudfunctions.net/getJoinedQueuesApi",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("idToken"),
        },
      }
    ).then((res) => {
      console.log("getJoinedQueuesApi responce :  ", res.data);
      if (res.data.success) {
        // console.log("userdetails success");
        console.log(res.data);
        setJoinedQueues(res.data.joinedQueues);
      } else {
        // console.log("userdetails failed");
        //   history.replace('/')
      }
    });
  }, []);

  const getCurrentQueues = () => {
    const currentQueue = joinedQueues.filter(
      (jQueue) =>
        moment(jQueue.queue.allotedTime).format("DD/MM/YYYY") ===
          moment().format("DD/MM/YYYY") &&
        moment(jQueue.queue.allotedTime).format("hh:mm") <=
          moment().format("hh:mm")
    );
    // console.log("currentQueue");
    return currentQueue;
  };

  const getUpcomingQueues = () => {
    const currentQueue = joinedQueues.filter(
      (jQueue) =>
        moment(jQueue.queue.allotedTime).format("DD/MM/YYYY") <
          moment().format("DD/MM/YYYY") ||
        (moment(jQueue.queue.allotedTime).format("DD/MM/YYYY") ===
          moment().format("DD/MM/YYYY") &&
          moment(jQueue.queue.allotedTime).format("hh:mm") <
            moment().format("hh:mm"))
    );
    // console.log("currentQueue");
    return currentQueue;
  };
  const getCompletedQueues = () => {
    const currentQueue = joinedQueues.filter(
      (jQueue) =>
        moment(jQueue.queue.allotedTime).format("DD/MM/YYYY") >
          moment().format("DD/MM/YYYY") ||
        (moment(jQueue.queue.allotedTime).format("DD/MM/YYYY") ===
          moment().format("DD/MM/YYYY") &&
          moment(jQueue.queue.allotedTime).format("hh:mm") >
            moment().format("hh:mm"))
    );
    // console.log("currentQueue");
    return currentQueue;
  };

  const forAll = (queue) => (
    <Grid item lg={4}>
      <Grid container className={classes.dataContainer}>
        <Grid container lg={6}>
          <Typography
            // style={{ color: "#5A9BB7", fontSize: "25px", marginBottom: "10px" }}
            className={classes.head1}
          >
            {queue.queue.facility.name}
          </Typography>
        </Grid>
        <Grid container lg={6} direction="row-reverse">
          <Typography
            style={{
              color:
                queue.queue.queueStatus === "Open"
                  ? "#22FCA8"
                  : queue.queue.queueStatus === "Cancelled"
                  ? "#FF4183"
                  : queue.queue.queueStatus === "Not Open"
                  ? "#5A9BB7"
                  : "#ffffff",
              fontSize: "12px",
              marginBottom: "10px",
              fontFamily: "'Poppins', sansSerif",
              fontWeight: "500",
            }}
          >
            {queue.queue.queueStatus}
          </Typography>
        </Grid>
        <Grid
          container
          lg={12}
          style={{ marginBottom: "1vw", marginTop: "1vw" }}
        >
          <Grid container style={{ width: "70%" }}>
            <Typography
              style={{
                color: "#5A9BB7",
                fontSize: "10px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "500",
              }}
            >
              {queue.queue.facility.address.formattedAddress}
            </Typography>
          </Grid>
        </Grid>
        <Grid container lg={12}>
          <Grid container item lg={4} justify="center">
            <Typography
              style={{
                color: "#5A9BB7",
                fontSize: "12px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "500",
              }}
            >
              Visit
            </Typography>
            <Divider
              style={{
                width: "85%",
                height: "2px",
                backgroundColor: "#39F4C4",
                marginTop: ".5vw",
                marginBottom: ".5vw",
              }}
            />
          </Grid>
          <Grid container item lg={4} justify="center">
            <Typography
              style={{
                color: "#5A9BB7",
                fontSize: "12px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "500",
              }}
            >
              You are
            </Typography>
            <Divider
              style={{
                width: "80%",
                height: "2px",
                backgroundColor: "#39F4C4",
                marginTop: ".5vw",
                marginBottom: ".5vw",
              }}
            />
          </Grid>{" "}
          <Grid container item lg={4} justify="center">
            <Typography
              style={{
                color: "#5A9BB7",
                fontSize: "12px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "500",
              }}
            >
              Covistors
            </Typography>
            <Divider
              style={{
                width: "80%",
                height: "2px",
                backgroundColor: "#39F4C4",
                marginTop: ".5vw",
                marginBottom: ".5vw",
              }}
            />
          </Grid>
        </Grid>
        <Grid container lg={12}>
          <Grid container item lg={4} justify="center">
            <Typography
              style={{
                color: "#22FCA8",
                fontSize: "12px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "400",
              }}
            >
              {moment(queue.queue.allotedTime).format("DD/MM/YYYY")}
              <Grid container justify="center">
                {moment(queue.queue.allotedTime).format("hh:mm")}
              </Grid>
            </Typography>
          </Grid>
          <Grid container item lg={4} justify="center">
            <Typography
              style={{
                color: "#22FCA8",
                fontSize: "12px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "400",
              }}
            >
              {queue.lineData ? (
                queue.lineData[0].isExited ? (
                  <>OUTSIDE</>
                ) : queue.lineData[0].isEntryScan ? (
                  <>ENTERED</>
                ) : moment(queue.queue.allotedTime) >= moment() ? (
                  <>LATE</>
                ) : (
                  <>IN QUEUE</>
                )
              ) : (
                <>IN QUEUE</>
              )}
            </Typography>
          </Grid>
          <Grid container item lg={4} justify="center">
            <Typography
              style={{
                color: "#A06EFF",
                fontSize: "24px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "400",
              }}
            >
              {queue.queue.covisitors}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
  return (
    <Grid container>
      <Grid container spacing={5}>
        <Grid item>
          <Grid
            container
            justify="center"
            alignContent="center"
            item
            className={classes.countContainer}
            onClick={() => setChoosenTab(0)}
            style={{
              boxShadow:
                choosenTab === 0
                  ? "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)"
                  : "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
            }}
          >
            <Typography
              className={classes.head1}
              style={{ color: choosenTab === 0 ? "#22FCA8" : "#5A9BB7" }}
            >
              All
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            justify="center"
            alignContent="center"
            item
            className={classes.countContainer}
            style={{
              boxShadow:
                choosenTab === 1
                  ? "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)"
                  : "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
            }}
            onClick={() => setChoosenTab(1)}
          >
            <Typography
              className={classes.head1}
              style={{ color: choosenTab === 1 ? "#22FCA8" : "#5A9BB7" }}
            >
              Current
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            justify="center"
            alignContent="center"
            item
            className={classes.countContainer}
            style={{
              boxShadow:
                choosenTab === 2
                  ? "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)"
                  : "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
            }}
            onClick={() => setChoosenTab(2)}
          >
            <Typography
              className={classes.head1}
              style={{ color: choosenTab === 2 ? "#22FCA8" : "#5A9BB7" }}
            >
              Completed
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            justify="center"
            alignContent="center"
            item
            className={classes.countContainer}
            style={{
              boxShadow:
                choosenTab === 3
                  ? "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)"
                  : "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
            }}
            onClick={() => setChoosenTab(3)}
          >
            <Typography
              className={classes.head1}
              style={{ color: choosenTab === 3 ? "#22FCA8" : "#5A9BB7" }}
            >
              Upcoming
            </Typography>{" "}
          </Grid>
        </Grid>
      </Grid>

      <Grid container style={{ marginTop: "2vw" }}>
        <Grid container spacing={3}>
          {choosenTab === 0
            ? joinedQueues.map((queue) => <>{forAll(queue)} </>)
            : choosenTab === 1
            ? getCurrentQueues().map((queue) => <> {forAll(queue)}</>)
            : choosenTab === 2
            ? getCompletedQueues().map((queue) => <> {forAll(queue)}</>)
            : choosenTab === 3
            ? getUpcomingQueues().map((queue) => <> {forAll(queue)}</>)
            : null}
        </Grid>
      </Grid>
    </Grid>
  );
}
